// Entry point for the build script in your package.json
// jQuery, Popper.js, Bootstrap e Rails UJS carregados via Sprockets

// 1. ActiveStorage
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// 2. Bootstrap 5 (npm — carrega todos os plugins JS, com Popper incluido)
import "bootstrap"

// 3. Cocoon (nested forms)
import "@nathanvda/cocoon"

// 4. jQuery plugins da app
import "./autocomplete-rails"
import "./jquery.mask.min"

// 5. ActionCable channels
import "./channels"

// 6. jQuery-dependent functionality (jQuery is global from Sprockets)
$(function () {
  $('[data-bs-toggle="popover"]').popover();
});
$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip({ trigger: "hover" })
})

$(document).keyup(function (event) {
  if (event.which === 27) {
    $('[data-bs-toggle="popover"]').popover('hide');
    $('[data-bs-toggle="tooltip"]').tooltip('hide');
  }
});